@if (!isBootstrapIcon) {
  <span><span [data-feather]="name"></span></span>
}
@if (isBootstrapIcon) {
  <span><i-bs [name]="name"></i-bs></span>
}
